import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {CoreService} from "../../../services/core.service";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {GlobalService} from "../../../services/global.service";
import {HttpClient} from "@angular/common/http";
import {
  GetLanguage,
  HandleResponseError,
  prepareServerDate,
  scanFileToUpload,
  validateFileType
} from "../../functions/shared-functions";
import {ShowLastReceiptsComponent} from "../../../modules/accounting/receipts/show-last-receipts/show-last-receipts.component";
import {
  ShowLastArbitrationReceiptComponent
} from "../../../modules/arbitration-center/arbitration-receipts/show-last-arbitration-receipt/show-last-arbitration-receipt.component";
import {
  ShowLastTrainingCenterReceiptsComponent
} from "../../../modules/training-center/training-center-receipts/show-last-training-center-receipts/show-last-training-center-receipts.component";
import {
  ShowLastTripsCenterReceiptsComponent
} from "../../../modules/trips/trips-receipts/show-last-trips-center-receipts/show-last-trips-center-receipts.component";
import {
  ShowOtherServicesLastReceiptComponent
} from "../../../modules/other-services/other-services-receipts/show-other-services-last-receipt/show-other-services-last-receipt.component";

@UntilDestroy()
@Component({
  selector: 'app-upload-receipt',
  templateUrl: './upload-receipt.component.html',
  styleUrls: ['./upload-receipt.component.scss']
})
export class UploadReceiptComponent implements OnInit {
  receiptData: any;
  file;
  doc_types = [];
  acceptedAvatarFileTypes = [
    'image/jpeg',
    'image/png',
    'image/jpg',
    'image/gif',
    'image/svg',
  ];
  avatarSrc;
  avatarRequirementsError;
  uploadOption = '1';
  selectedImage;
  loading = true;
  system;

  constructor(private activatedRoute: ActivatedRoute,
              private coreService: CoreService,
              private toastr: ToastrService,
              private translate: TranslateService,
              private router: Router,
              private dialog: MatDialog,
              private globalService: GlobalService,
              private httpClient: HttpClient,
              private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    this.system = this.activatedRoute.snapshot.queryParams['system'];
    if (this.system) {
      const data = this.activatedRoute.snapshot.data.receipt?.body[0];
      this.receiptData = {...data?.persondata, ...data?.serviceRequest[0], ...data}
    } else {
      this.receiptData = this.activatedRoute.snapshot.data.receipt[0];
    }
    console.log('re', this.receiptData)
    if (this.receiptData?.documentList?.length) {
      if (!this.receiptData?.documentList[0]?.filePath?.includes('http')) {
        this.getDocFile(this.receiptData?.documentList[0]?.id);
      } else {
        this.avatarSrc = this.receiptData?.documentList[0]?.filePath;
        this.loading = false;
      }
    } else {
      this.loading = false;
    }
    this.getDocTypes();
  }

  getDocFile(id) {
    if (this.system) {
      this.coreService
        .getRequest(`Oneincome/api/Document/${id}?SystemActionCode=${this.receiptData?.systemActionCode}`, {}, true, false)
        .pipe(untilDestroyed(this))
        .subscribe((res) => {
          this.avatarSrc = res?.filePath;
          this.loading = false;
        }, error => {
          this.loading = false;
        });
    } else {
      this.coreService
        .getRequest(`Document/${id}`)
        .pipe(untilDestroyed(this))
        .subscribe((res) => {
          this.avatarSrc = res?.filePath;
          this.loading = false;
        }, error => {
          this.loading = false;
        });
    }
  }

  submit() {
    if (this.file) {
      if (this.receiptData?.documentList?.length && this.receiptData?.documentList[0]?.id) {
        // he had a file and removed it and uploaded another file so remove the exist one and post new one
        this.removeReceiptImage(true);
      } else {
        this.uploadReceipt();
      }
    } else {
      // remove file from that receipt if user removed it by x icon
      if (
        !this.file &&
        !this.avatarSrc &&
        this.receiptData?.documentList[0]?.id &&
        this.uploadOption === '1'
      ) {
        this.removeReceiptImage();
      } else if (this.selectedImage && this.uploadOption === '2') {
        this.putChosenReceiptImage();
      } else {
      }
    }
  }

  addFile(event) {
    event.preventDefault();
    const files = event.target.files[0];
    if (files) {
      for (let type of this.acceptedAvatarFileTypes) {
        if (files.type === type) {
          if (validateFileType(files)) {
            scanFileToUpload(
              files,
              this.translate,
              this.toastr,
              this.httpClient,
            ).then((res) => {
              this.file = files;
              // this.uploadImage();
              const reader = new FileReader();
              const _this = this;
              reader.addEventListener(
                'load',
                function () {
                  _this.avatarSrc = reader.result;
                },
                false,
              );
              reader.readAsDataURL(this.file);
              this.avatarRequirementsError = void 0;
              return;
            });
          } else {
            this.avatarRequirementsError = 'Image max size must not exceed 2MB';
          }
        }
      }
    }
  }

  uploadReceipt() {
    const PID = this.receiptData?.personDataId ?? this.receiptData?.persondata?.id
    const form_data = new FormData();
    form_data.append('PersonDataId', PID);
    form_data.append('CasherId', this.receiptData?.id);
    form_data.append(
      'DocumentDate',
      prepareServerDate(this.receiptData.receiptDate),
    );
    form_data.append('Desc', 'test');
    form_data.append('isPrivet', 'false');
    form_data.append('Comment', 'test');
    form_data.append(
      'DocumentTypeId',
      this.doc_types?.find((x) => x.actionCode === 'PaymentReceipt')?.id,
    );
    form_data.append('Files', this.file);
    form_data.append('auditPageCode', 'BoShowCandidateAdd');
    if (this.system) {
      form_data.append('SystemActionCode', this.receiptData?.systemActionCode);
      form_data.append('NeededSystemActionCode', this.system);
      this.coreService.postRequest('Oneincome/api/vpersondata/UplaodDocs', form_data, {
        observe: 'response',
        responseType: 'json',
      },true, true).subscribe(
        (res) => {
          this.translate.get('Added successfully').subscribe((word) => {
            this.toastr.success(word);
          });
        },
        (err) => {
          this.toastr.error(HandleResponseError(err));
        },
      );
    } else {
      this.coreService.postRequest('Document/UplaodDocs', form_data).subscribe(
        (res) => {
          this.translate.get('Added successfully').subscribe((word) => {
            this.toastr.success(word);
          });
        },
        (err) => {
          this.toastr.error(HandleResponseError(err));
        },
      );
    }
  }

  openImageViewer(path) {
    console.log('path', path)
    this.globalService.imageViewer.next(path);
  }

  getDocTypes() {
    this.coreService.getRequest('DocumentType').subscribe(
      (res) => {
        res?.map(
          (item) =>
            (item.name =
              GetLanguage() === 'ar' ? item.nameArabic : item.nameEng),
        );
        res?.map(
          (item) =>
            (item.typeInfo =
              GetLanguage() === 'ar' ? item.typeInfoAr : item.typeInfoEn),
        );
        this.doc_types = res;
      },
      (err) => {
      },
      () => {
      },
    );
  }

  removeFile() {
    this.file = void 0;
    this.avatarSrc = void 0;
    this.removeReceiptImage();
  }

  removeReceiptImage(thenUpload?) {
    if (this.system) {
      if (this.receiptData?.documentList?.length && this.receiptData?.documentList[0]?.filePath) {
        const form_data = {
          casherId: null,
          documentTypeId: this.receiptData?.documentList[0]?.documentTypeId,
          NeededSystemActionCode: this.system,
          SystemActionCode: this.receiptData?.systemActionCode,
        };
        this.coreService
          .putRequest(
            `Oneincome/api/Document/${this.receiptData?.documentList[0]?.id}`,
            form_data, true, false
          )
          .subscribe(
            (res) => {
              if (thenUpload) {
                this.receiptData.documentList[0] = void 0;
                this.uploadReceipt();
              } else {
                this.translate
                  .get('Removed file successfully')
                  .subscribe((word) => {
                    this.toastr.success(word);
                  });
              }
            },
            (err) => {
              this.toastr.error(HandleResponseError(err));
            },
          );
      }
    } else {
      const form_data = {
        casherId: null,
        documentTypeId: this.receiptData?.documentList[0]?.documentTypeId,
      };
      this.coreService
        .putRequest(
          `Document/${this.receiptData?.documentList[0]?.id}`,
          form_data,
        )
        .subscribe(
          (res) => {
            if (thenUpload) {
              this.receiptData.documentList[0] = void 0;
              this.uploadReceipt();
            } else {
              this.translate
                .get('Removed file successfully')
                .subscribe((word) => {
                  this.toastr.success(word);
                });
            }
          },
          (err) => {
            this.toastr.error(HandleResponseError(err));
          },
        );
    }
  }

  openLastReceiptsDialog() {
    let componentToOpen: any;

    switch (this.system) {
      case 'arbitrator':
        componentToOpen = ShowLastArbitrationReceiptComponent;
        break;
      case 'Traninng':
        componentToOpen = ShowLastTrainingCenterReceiptsComponent;
        break;
      case 'Trip':
        componentToOpen = ShowLastTripsCenterReceiptsComponent;
        break;
      case 'OneIncome':
        componentToOpen = ShowOtherServicesLastReceiptComponent;
        break;
      default:
        componentToOpen = ShowLastReceiptsComponent;
    }

    const dialogRef = this.dialog.open(componentToOpen, {
      data: {
        receiptData: this.receiptData,
      },
      direction: GetLanguage() === 'ar' ? 'rtl' : 'ltr',
      maxHeight: '90vh',
      width: '50%',
    });

    return dialogRef.afterClosed().subscribe((res) => {
      if (res?.selectedRow) {
        this.selectedImage = res.selectedRow;
        console.log('this.selectedImage', this.selectedImage);
      }
    });
  }

  putChosenReceiptImage() {
    if (this.system) {
      const form_data = {
        casherId: this.receiptData?.id,
        documentTypeId: this.selectedImage?.documentTypeId,
        filePath: this.receiptData?.documentList[0]?.filePath,
        NeededSystemActionCode: this.system,
        SystemActionCode: this.receiptData?.systemActionCode,
      };
      this.coreService
        .putRequest(`Oneincome/api/Document/${this.selectedImage?.id}`, form_data, true, false)
        .subscribe(
          (res) => {
            this.translate.get('File tied successfully').subscribe((word) => {
              this.toastr.success(word);
            });
          },
          (err) => {
            this.toastr.error(HandleResponseError(err));
          },
        );
    } else {
      const form_data = {
        casherId: this.receiptData?.id,
        documentTypeId: this.selectedImage?.documentTypeId,
        filePath: this.receiptData?.documentList[0]?.filePath,
      };
      this.coreService
        .putRequest(`Document/${this.selectedImage?.id}`, form_data)
        .subscribe(
          (res) => {
            this.translate.get('File tied successfully').subscribe((word) => {
              this.toastr.success(word);
            });
          },
          (err) => {
            this.toastr.error(HandleResponseError(err));
          },
        );
    }
  }
}
